import { gql } from '@apollo/client';
const WITHDRAW_TEMPLATE_ELEMENT = gql `
  mutation WithdrawTemplateElement($templateElementId: ID!) {
    removeAssignedModelSpecificationTemplateElement(assignedTemplateElementId: $templateElementId) {
      removed
    }
  }
`;
export default WITHDRAW_TEMPLATE_ELEMENT;
